<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8444 5.91728L19.2687 3.31795C19.6454 2.91406 20.2782 2.89201 20.6821 3.2687C21.0859 3.64539 21.108 4.27817 20.7313 4.68205L18.7372 6.82018C21.3308 8.31158 23 10.4253 23 12C23 14.7048 18.0751 19 12 19C10.5777 19 9.21844 18.7624 7.97067 18.3642L5.7313 20.7653C5.35462 21.1692 4.72184 21.1912 4.31795 20.8145C3.91406 20.4378 3.89201 19.8051 4.2687 19.4012L5.98792 17.5578C2.98447 16.0562 1 13.6915 1 12C1 9.33533 5.92487 5 12 5C13.7385 5 15.3828 5.35174 16.8444 5.91728ZM14.2538 8.69496C13.612 8.25645 12.836 8 12 8C9.79086 8 8 9.79086 8 12C8 12.936 8.32147 13.7969 8.86002 14.4783L10.2566 12.9808C10.0932 12.691 10 12.3564 10 12C10 10.8954 10.8954 10 12 10C12.3068 10 12.5974 10.0691 12.8572 10.1925L14.2538 8.69496ZM12.0413 13.9996C13.1268 13.9776 14 13.0908 14 12C14 11.9671 13.9992 11.9345 13.9976 11.902L15.5773 10.2083C15.8477 10.7473 16 11.3559 16 12C16 14.2091 14.2091 16 12 16C11.4548 16 10.9351 15.8909 10.4615 15.6934L12.0413 13.9996Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'IconHidePassword',
};
</script>
